"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_1 = require("@mdi/js");
var react_1 = __importStar(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../../");
var StyledTable = (0, styled_components_1.default)(react_bootstrap_1.Table)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  // Your styles here\n  border: 2px solid grey;\n  border-radius: 5px !important;\n  min-height: 40vh;\n"], ["\n  // Your styles here\n  border: 2px solid grey;\n  border-radius: 5px !important;\n  min-height: 40vh;\n"])));
var DropZone = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 40vh;\n  text-align: center;\n  width: 100%;\n  overflow: hidden;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 40vh;\n  text-align: center;\n  width: 100%;\n  overflow: hidden;\n"])));
var FileTable = function (_a) {
    var folderPath = _a.folderPath, actions = _a.actions, color = _a.color, uploadCallBack = _a.uploadCallBack, noAuth = _a.noAuth, otherUser = _a.otherUser, setSelectedState = _a.setSelectedState;
    var _b = (0, react_1.useState)([]), files = _b[0], setFiles = _b[1];
    var _c = (0, react_1.useState)(false), dragging = _c[0], setDragging = _c[1];
    var _d = (0, react_1.useState)(false), manual = _d[0], setManual = _d[1];
    var _e = (0, react_1.useState)([]), selectedFiles = _e[0], setSelectedFiles = _e[1]; // Local state for selected files
    var logic = (0, __1.useEloise)().logic;
    (0, react_1.useEffect)(function () {
        if (!noAuth) {
            var fetchFiles = function () { return __awaiter(void 0, void 0, void 0, function () {
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, logic.fb.storageMethods.getUserStorageFolder(folderPath)];
                        case 1:
                            result = _a.sent();
                            if (result) {
                                setFiles(result);
                            }
                            return [2 /*return*/];
                    }
                });
            }); };
            fetchFiles();
        }
    }, [folderPath, manual]);
    var getResult = function (file) { return __awaiter(void 0, void 0, void 0, function () {
        var x, x, x;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!otherUser) return [3 /*break*/, 2];
                    return [4 /*yield*/, logic.fb.storageMethods.uploadOtherUserFile(folderPath, otherUser, file)];
                case 1:
                    x = _a.sent();
                    return [2 /*return*/, x];
                case 2:
                    if (!noAuth) return [3 /*break*/, 4];
                    return [4 /*yield*/, logic.fb.storageMethods.uploadFileNoAuth(folderPath, file)];
                case 3:
                    x = _a.sent();
                    return [2 /*return*/, x];
                case 4: return [4 /*yield*/, logic.fb.storageMethods.uploadFile(folderPath, file)];
                case 5:
                    x = _a.sent();
                    return [2 /*return*/, x];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        // When a file is selected or unselected, use the prop to update the parent component.
        if (setSelectedState) {
            setSelectedState(selectedFiles);
        }
    }, [selectedFiles, setSelectedState]);
    var toggleFileSelected = function (file) {
        setSelectedFiles(function (prevSelectedFiles) {
            if (prevSelectedFiles.includes(file)) {
                return prevSelectedFiles.filter(function (f) { return f !== file; });
            }
            else {
                return __spreadArray(__spreadArray([], prevSelectedFiles, true), [file], false);
            }
        });
    };
    var onDragOver = function (event) {
        event.preventDefault();
        setDragging(true);
    };
    var onDragLeave = function () {
        setDragging(false);
    };
    var onDrop = (0, react_1.useCallback)(function (event) {
        event.preventDefault();
        setDragging(false);
        Array.from(event.dataTransfer.files).forEach(function (file) { return __awaiter(void 0, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getResult(file)];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            if (uploadCallBack) {
                                uploadCallBack();
                            }
                            setFiles(function (prevFiles) { return __spreadArray(__spreadArray([], prevFiles, true), [result], false); });
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    }, [folderPath]);
    var fileInputRef = (0, react_1.useRef)(null); // Create a ref
    var onIconClick = function () {
        if (fileInputRef.current) {
            fileInputRef.current.click(); // Trigger the click on the hidden file input
        }
    };
    var onFileInputChange = function (event) {
        var files = event.target.files;
        if (files) {
            Array.from(files).forEach(function (file) { return __awaiter(void 0, void 0, void 0, function () {
                var result, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!noAuth) return [3 /*break*/, 2];
                            return [4 /*yield*/, logic.fb.storageMethods.uploadFileNoAuth(folderPath, file)];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, logic.fb.storageMethods.uploadFile(folderPath, file)];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            result = _a;
                            if (result) {
                                if (uploadCallBack) {
                                    uploadCallBack();
                                }
                                setFiles(function (prevFiles) { return __spreadArray(__spreadArray([], prevFiles, true), [result], false); });
                            }
                            return [2 /*return*/];
                    }
                });
            }); });
        }
    };
    var getFileExtension = function (file) {
        var parts = file.name.split(".");
        return parts.length > 1 ? ".".concat(parts[parts.length - 1]) : "";
    };
    var actionHandler = function (action, file) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, action.action(file)];
                case 1:
                    _a.sent();
                    setManual(!manual);
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(StyledTable, { onDragOver: onDragOver, onDragLeave: onDragLeave, onDrop: onDrop, striped: true, bordered: true, hover: true, responsive: true },
        react_1.default.createElement("input", { type: "file", ref: fileInputRef, style: { display: "none" }, onChange: onFileInputChange }),
        react_1.default.createElement("thead", null,
            react_1.default.createElement("tr", null,
                setSelectedState && react_1.default.createElement("th", null, "Select"),
                react_1.default.createElement("th", null, "File Name"),
                !(files.length === 0 || dragging) &&
                    actions.map(function (action, index) { return react_1.default.createElement("th", { key: index }, action.text); }))),
        react_1.default.createElement("tbody", null, files.length === 0 || dragging ? (react_1.default.createElement("tr", null,
            react_1.default.createElement("td", null,
                react_1.default.createElement(DropZone, { className: "mx-auto" },
                    react_1.default.createElement(__1.AppIcon, { title: "upload file", onClick: onIconClick, icon: js_1.mdiFileUploadOutline, color: "grey", size: 3 }))))) : (files.map(function (file, fileIndex) { return (react_1.default.createElement("tr", { key: fileIndex },
            setSelectedState && (react_1.default.createElement("td", null,
                react_1.default.createElement("input", { type: "checkbox", checked: selectedFiles.some(function (f) { return f.fullPath === file.fullPath; }), onChange: function () { return toggleFileSelected(file); } }))),
            react_1.default.createElement("td", null, file.name),
            actions.map(function (action, actionIndex) { return (react_1.default.createElement("td", { key: actionIndex },
                react_1.default.createElement(__1.Button, { style: { padding: "2px 5px" }, color: color !== null && color !== void 0 ? color : 0, onClick: function () { return actionHandler(action, file); } }, action.text))); }))); })))));
};
exports.default = FileTable;
var templateObject_1, templateObject_2;
